import styles from './AIResponseLog.module.scss'

/**
 * @param {{ isLast?: boolean }} props
 */
export default function TraceTimeline({ isLast = false }) {
  return (
    <div className={styles.timelineRail} aria-hidden>
      <span className={styles.timelineDot} />
      {!isLast ? <span className={styles.timelineLine} /> : null}
    </div>
  )
}
